import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Align from '@marvelapp/marvel-ui/align';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';
import caseStudiesAssets from 'marketing-website/configs/caseStudies';

import Image from '../../Image';

export default function DoubleImageBlock({ name, keyName }) {
  const assets = caseStudiesAssets[name];
  const image = assets.singleImages[keyName];

  return (
    <Spacing size="m" sizeS="l" sizeM="xl" position="topBottom" type="padding">
      <PageWrap>
        <Align type="center">
          {image.src && (
            <Image
              color="snow--d"
              hasShadow={false}
              {...image}
              useImageTag={true}
            />
          )}
        </Align>
      </PageWrap>
    </Spacing>
  );
}

DoubleImageBlock.propTypes = {
  name: propTypeEmptyString,
  keyName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/ImageBlock/index.js